import { createBrowserRouter } from 'react-router';
import {
  AdminShell,
  adminDashboardRoutes,
  adminOrganizationsRoutes,
  adminAiServicesRoutes,
  adminAdminsRoutes,
  adminPackageRegistriesRoutes,
} from '@redbax/ui-admin';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AdminShell />,
    children: [
      ...adminDashboardRoutes,
      ...adminOrganizationsRoutes,
      ...adminAiServicesRoutes,
      ...adminAdminsRoutes,
      ...adminPackageRegistriesRoutes,
    ],
  },
]);
